<div id="tipView" 
    [ngClass]="popupXPosition >10 ? 'show_tip': 'hide_tip'"
    [ngClass]="{'show_tip': popupXPosition >10, 'hide_tip': popupXPosition <=10, 'extended-width': useExtendedWidth}"
    [style.left.px]="popupXPosition" 
    [style.top.px]="popupYPosition" 
    class="toolTipView">
    <div class="toolTipHeader">
        {{ff_message}}
    </div>
</div>